var React = require('react');

function ChevronLt (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"working"},React.createElement("g",{"id":"icons-_-widgets","data-name":"icons- -widgets"},React.createElement("polygon",{"id":"chevron-rt","points":"3.79 8.1 10 1.9 8.1 0 0 8.1 8.1 16.21 10 14.31 3.79 8.1"}))));
}

ChevronLt.defaultProps = {"width":"10px","className":"icon icon-middle","viewBox":"0 0 10 16.21"};

module.exports = ChevronLt;

ChevronLt.default = ChevronLt;
